export default {
  en: {
    title: 'Dashboard',
    fetchingFailed: 'Failed to get dashboard metrics. Please retry or contact Risk Ledger support.',
    retry: 'Retry',
    openRisks: {
      title: 'Open risks',
      help: 'Number of risks that {org} opened and is monitoring.',
      open: 'Open',
      closed: 'Closed',
    },
    totalSubEntities: {
      title: 'Total sub-entities',
      help: 'Number of organisations in your federated group.',
      pendingInvitesCount: 'Pending invites',
      expiredInvitesCount: 'Expired invites',
      cancelledInvitesCount: 'Cancelled invites',
    },
    totalSuppliers: {
      title: 'Total suppliers',
      help: 'Number of organisations directly supplying all your sub-entities.',
    },
    totalNetwork: {
      title: 'Total network',
      help: 'Number of organisations that make up your entire federated network, including sub-entities and their supply chains.',
      nthDegree: {
        '1': 'Sub-entity | Sub-entities',
        '2': 'Supplier | Suppliers',
        '3': '{ordinal} party supplier | {ordinal} party suppliers',
      },
    },
    misc: {
      viewNetwork: 'View network',
    },
  },
};
